import { Directive, ElementRef, HostListener, Input, OnInit, Renderer2 } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { UtilsService } from '@app/core/services';

@Directive({
	selector: '[CopyText]',
	standalone: true
})

export class CopyTextDirective implements OnInit {
	@Input() text: string;
	constructor(
		private el: ElementRef,
		private renderer: Renderer2,
		private utilService: UtilsService
	) {
	}

	ngOnInit(): void {
		this.makeTooltipElement();
	}

	makeTooltipElement(): void{
		const tooltip = this.renderer.createElement('span');
		this.renderer.setAttribute(tooltip, 'class', 'tooltip copy');
		this.renderer.appendChild(this.el.nativeElement, tooltip);
		
	}
	copyText(text: string) {
        const selBox = document.createElement('textarea');
        selBox.style.position = 'fixed';
        selBox.style.left = '0';
        selBox.style.top = '0';
        selBox.style.opacity = '0';
        selBox.value = text;
        document.body.appendChild(selBox);
        selBox.focus();
        selBox.select();
        document.execCommand('copy');
        document.body.removeChild(selBox);
    }

	@HostListener('click') onMouseLeave() {
		this.copyText(this.text);
		this.el.nativeElement.classList.add('show-copy-text');
		setTimeout(()=>{
			this.el.nativeElement.classList.remove('show-copy-text');
		}, 1300);
	  }
}
